import classNames from 'classnames';
import { mergeStyles } from '../../common/Utils/mergeStyles';
import { sizeClassName as sizeClassNameFromCommon } from '../../common/Utils/classNameStrategies';
import viewerStyles from './styles/video-viewer.scss';
export var containerClassName = function (theme) {
    if (theme === void 0) { theme = {}; }
    var mergedStyles = mergeStyles({ styles: viewerStyles, theme: theme });
    return mergedStyles.video_container;
};
export var sizeClassName = function (componentData, theme, styles, isMobile) {
    var className = sizeClassNameFromCommon(componentData, theme, styles);
    return classNames(className, theme['videoPlugin']);
};
//# sourceMappingURL=classNameStrategies.js.map